module.exports = {
  key: 'en-gb',
  extends: 'en',
  volcabulary: {},
  terms: {}
}